import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_global_get_init_country_message } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import Header from "../../fragments/heading/index";
import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import { BigButton } from '../../../../components/button'
import { fetchByOrderId } from '../../../../../api'


const Tracking = props =>{
    const { data } = props;
    const { placeholder, btnText, errorMsg } = data;
    const [orderNum, setOrderNum] = useState('');
    const global = useSelector(state=>state.global);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleTracking = async () =>{
        try {
            setLoading(true);
            let response = await fetchByOrderId(orderNum);
            if(response?.code === 200 && response?.result){
                window.history.pushState({},'tracking',window.location.href);
                window.location.href = `/user/order/tracking/${orderNum}`;
            }else{
                setShowError(true);
            }

            setLoading(false);
        } catch (error) {
            setShowError(true);
            setLoading(false);
        }
        
    }

    const handleSubmit = async (event) =>{
        event.preventDefault();
        if(!global?.user?.id){
            window.location.href = `/i/login?redirectUrl=${window.location.href}`
            return;
        }

        handleTracking();
    }

    return <div className={classes.TrackingCon}>
        <form action="#" onSubmit={handleSubmit}>
            <div className={classes.Container}>
                <div className={classes.Input}>
                    <input 
                        type="text" 
                        placeholder={placeholder} 
                        value={orderNum} 
                        required
                        onChange={(event) =>{
                            setShowError(false);
                            setOrderNum(event.target.value)
                        }} 
                    />
                </div>

                <BigButton loading={loading} className={classes.Btn}>{btnText}</BigButton>
            </div>
        </form>

        {
            showError && <div className={classes.ErrorMsg}>{errorMsg}</div>
        }
    </div>
}

const OrderTracking = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state=>state.pagePolicy);
    const global = useSelector(state=>state.global);
    const { config } = global;

    const messageContent1 = useMemo(() =>{
        if(pagePolicy?.orderTracking?.content1){
            let message = pagePolicy?.orderTracking?.content1;
            message = message.replace("#siteLabel", config?.name);
            // whatsAppId1 -- > whatsAppId2
            message = message.replace("#siteWhatapp", config?.policy?.whatsAppId2);
            message = message.replace("#siteMessageus", config?.policy?.messageUs);
            return message; 
        }else{
            return null;
        }
    },[pagePolicy?.orderTracking?.content1]);

    const messageContent3 = useMemo(() =>{
        if(pagePolicy?.orderTracking?.content3){
            let message = pagePolicy?.orderTracking?.content3;
            message = message.replace("#siteLabel", config?.name);
            // whatsAppId1 -- > whatsAppId2
            message = message.replace("#siteWhatapp", config?.policy?.whatsAppId2);
            message = message.replace("#siteMessageus", config?.policy?.messageUs);
            return message; 
        }else{
            return null;
        }
    },[pagePolicy?.orderTracking?.content3]);

    return <React.Fragment>
        <Header centerSlot={<FormattedMessage id="order_tracking" defaultMessage="Order Tracking" />} />

        {
            messageContent1 && <div className={classes.Container} dangerouslySetInnerHTML={{ __html: messageContent1 }}></div>
        }

        {
            pagePolicy?.orderTracking?.content2 && <Tracking data={pagePolicy?.orderTracking?.content2} />
        }
        
        {
            messageContent3 && <div className={classes.Container} dangerouslySetInnerHTML={{ __html: messageContent3 }}></div>
        }

    </React.Fragment>
}

OrderTracking.fetchData = async (store, params, search, headers) => {
    // let data = {
    //     orderTracking:{
    //         "content1":" <div class=\"here-are-three-ways\"> Here are Three ways for you to check your order status<span class=\"text-style-1\">:</span> </div> <div class=\"track-orders-on-chic-me\">1 Track orders on #siteLabel</div>",
    //         "content2":{
    //             "btnText":"CHECK",
    //             "placeholder":"Input Order Number",
    //             "errorMsg":"Oops，can't track your order,please don't worry,you can track your order via the second method."
    //         },
    //         "content3":"<div class=\"contact-us\">2. Contact us</div> <div class=\"my_center_div\"> <div class=\"rectangle_first\"> <div class=\"first\"> <div><i class=\"iconfont logo\">&#xe795;</i></div> <div> Live Chat</div> </div> <div class=\"we-also-provide-a-convenient-customer\"> We also provide a convenient customer service-- Facebook Messenger, we are ready to help you with any inquires. <span class=\"text-style-1\">Just <a style=\"color:blue;text-decoration:underline\" href=\"#siteMessageus\">start Now!</a></span> </div> </div> <div class=\"rectangle_second\"> <div class=\"second\"> <div><i class=\"iconfont logo\">&#xe796;</i></div> <div>Messages</div> </div> <div class=\"if-you-need-any-after-sale\"> If you need any after-sale service, just submit a ticket, and we will reply in 24 hours!(Log in—Select one order—Click \"Detail\" —Click \"Contact Seller\". </div> </div> <div class=\"communication\"> <div class=\"bossdiv\"> <div class=\"customer-service\">Customer Service</div> <div class=\"whatsapp\"> <a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=#siteWhatapp\"> <img src=\"https://s3-us-west-2.amazonaws.com/image.chic-fusion.com/chicme/policy/whatsapp.jpg\"> </a> </div> </div> </div> </div> <div class=\"check-the-status-of-your-order-in-your-account\">3. Check the status of your order in your account </div> <div class=\"left_right1\"> <div> <div class=\"steps-one\">Steps 1</div> <div class=\"myclick\">Sign into “My Account”</div> <div class=\"order_logo\"> <i class=\"iconfont first\">&#xe78d;</i> </div> <div class=\"order_logo\"> <i class=\"iconfont second\">&#xe78d;</i> </div> <div class=\"myclick\"> Click”Track Order”</div> </div> <div> <div class=\"mybg\"></div> </div> </div> <div class=\"mydiv\"> <div class=\"left_right1\"> <div> <div class=\"steps-one\">Steps 2</div> <div class=\"myclick\">Select an order</div> <div class=\"order_logo\"> <i class=\"iconfont first\">&#xe78d;</i> </div> <div class=\"order_logo\"> <i class=\"iconfont second\">&#xe78d;</i> </div> <div class=\"myclick\">Click\"Track\"</div> </div> <div> <div class=\"mybg2\"></div> </div> </div> </div>"
    //     }
    // };
    await store.dispatch(action_global_get_init_country_message("M1711", "orderTracking", headers))
}

export default OrderTracking
